import PropTypes from 'prop-types';
// material
import Typography from '@mui/material/Typography';

CartVoucherStatus.propTypes = {
  voucher: PropTypes.object
};

export default function CartVoucherStatus({ voucher }) {
  if (voucher.isValid === false) {
    return <Typography color="error">(not applicable)</Typography>;
  }

  return <></>;
}
